import axios from "./request";
// import qs from 'qs'
const ip = window.fyEarth.ip
//console.log('window.fyEarth.ip', ip)
// const paletteIp = window.fyEarth.paletteIp tabPathName, isFinal, menuType
export function _menuList(area, params){
    return axios.get(`${ip}/service/menu/${area}`, {
        params: params
    })
    // return axios.get(`${window.downloadIp}/service/menutest/${area}`)
    // return axios.get('../../menu.json')
    // return axios.get('../../json_ces/menu.json')
}

// 全部产品列表
// http://121.36.13.81:4675/service/prod?group[]=Cloud map&group[]=111
export function _productList(area, params){
    return axios.get(`${ip}/service/prod/${area}`, {
        params: {
            group: params
        }
    })
    // return axios.get(`${window.fyEarth.ip}/service/prodtest`, {
    //     params: {
    //         group: params
    //     }
    // })
}
// http://121.36.13.81:4675/service/region/China regional cloud map
export function _regionList(params, subGroup){
    return axios.get(`${ip}/service/region/` + params, {
        params: {
            subGroup: subGroup
        }
    })
}

// 某通道产品列表
export function _filterImg(params){
    return axios.post(`${ip}/service/data`, params)
    // return axios.post(`${ip}/service/datatest`, params)
}

// 单区域动画组
// http://121.36.13.81:4675/service/data/one?region=China&interval=5&startTime=2021-07-07&endTime=2022-07-10
export function _filterGroupImg(params){
    return axios.post(`${ip}/service/data/one/`, params)
}

// 调色板
// http://10.25.21.157:4600/service/catalog/palette?prod=SNC&version=2.0
export function _palette(paletteUrl){
    // return axios.get(`${paletteIp}/service/catalog/palette`+ '/test-json?version=2.0') // test-json WID-02
    // return axios.get(`http://121.36.13.81:4600/service/catalog/palette`+ '/WID-02?version=2.0') // test-json WID-02
    return axios.get(`${paletteUrl}?version=2.0`)
}

// 图片下载
// http://10.25.21.157:4670/service/data/download
// http://121.36.13.81:4675/service/images/downloadtest/gif
export function _download(area, type, params){
    return axios.post(`${ip}/service/images/${area}/downloadtest/${type}`, params, { responseType: 'blob' })
}

// export function _download(type, params){
//     return axios.get(`${window.fyEarth.ip}/service/images/download/${type}`, {
//         params:params
//     },
//     { responseType : 'blob' })
// }

// 产品说明
// http://10.25.21.157:4670/service/note/6318722ad5af5031e5a99aa5
export function _note(id){
    return axios.get(`${ip}/service/catalog/prodabout/` + id)
}

export function _SummerMonsoonFilterImg(params){
    return axios.post(`${ip}/service/summerdata`, params)
}


// 获取产品
// http://121.36.13.81:4675/service/images?abbr=ACS&region=Western Asia
export function _getProdList(area, params){
    return axios.get(`${ip}/service/images/${area}`, {
        params: params
    })
}

// 模式校验产品
// http://fyearth.nsmc.org.cn/service/images/asia/forecast?abbr=AMVI&regoin=WesternAsia
export function _nwpProdList(area, params){
    return axios.get(`${ip}/service/images/${area}/forecast`, {
        params: params
    })
}